export default __webpack_public_path__ + "f9a502c90c6ee41a2ef66ce2699bb768.png";